import { ContactFormDTO } from 'types/contact';
import { request } from 'utils/request';

export const submitContactForm = async (contactData: ContactFormDTO) =>
    await request('/question/create', { method: 'POST' }, contactData);
